import type { App } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

export const setupElementPlus = (app: App<Element>) => {
  app.use(ElementPlus)
  // 全量注册 element-plus 图标组件（如 <el-icon><HomeFilled/></el-icon>）
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
}
